export enum RouteConstants {
  LandingPage = "landing",
  Logout = "logout",
  PageNotFound = "page-not-found",
  NoBudget = "no-budget",
  NoAIFeaturePermissions = "no-permission",
  Chatbot = "chatbot",
  ImageGeneration = "image-generation",
  Summary = "summary",
  Transcription = "transcription",
  Translation = "translation",
  ContentManagement = "contentManagement",
  RejectedTermsOfUse = "rejected-terms-of-use",
  AdminArea = "admin-area",
  Ai = "ai",
}
